export const board = {
  columns: [
    {
      id: 1,
      title: "Backlog",
      cards: [
        {
          id: 1.1,
          title: "Card title 1",
          description: "Card content",
        },
        {
          id: 1.2,
          title: "Card title 2",
          description: "Card content",
        },
        {
          id: 1.3,
          title: "Card title 3",
          description: "Card content",
        },
      ],
    },
    {
      id: 2,
      title: "Doing",
      cards: [
        {
          id: 2.1,
          title: "Card title 9",
          description: "Card content",
        },
      ],
    },
    {
      id: 3,
      title: "Q&A",
      cards: [
        {
          id: 3.1,
          title: "Card title 10",
          description: "Card content",
        },
        {
          id: 3.2,
          title: "Card title 11",
          description: "Card content",
        },
      ],
    },
    {
      id: 4,
      title: "Production",
      cards: [
        {
          id: 4.1,
          title: "Card title 12",
          description: "Card content",
        },
        {
          id: 4.2,
          title: "Card title 13",
          description: "Card content",
        },
      ],
    },
  ],
};
